<script lang="ts">
  import { push } from 'svelte-spa-router';
  import { formatDate, formatTime } from '../components/Util.svelte';
  import { loginUser } from '../components/auth/LoginUser';
  import Pagenation from '../components/pagenation/Pagenation.svelte';
  import Loading from '../etc/loader.svelte';
  import RepositoryFactory, { HATENOHAMA } from '../repositories/RepositoryFactory';
  import type { VoiceDetailResult } from '../repositories/hatneohama';

  // 取得月数
  const month: number = 6;
  const businessCode = $loginUser.businessCode;

  interface calldate {
    name: string;
    param: string;
  }
  let callDates: calldate[] = [];
  let selectedParam: calldate;
  let currentDate: Date = (() => {
    let date = new Date();
    // 月初
    date.setDate(1);
    // UMOBILEDの場合は先々月起点のためひと月マイナス
    if (isUmobiled() || isPremium()) {
      date.setMonth(date.getMonth() - 1);
    }
    return date;
  })();

  // 当月含まない直近の設定月数を取得
  for (let i: number = 0; i < month; i++) {
    currentDate.setMonth(currentDate.getMonth() - 1);
    let date = formatSelectDate(currentDate);
    if (i === 0) {
      selectedParam = date;
    }
    callDates.push(date);
  }

  // 初期表示用に最新月の通話明細を取得
  let voiceDetailYm = selectedParam.name;
  let useym = selectedParam.param;
  let totalPageSize = 0;
  let currentPage = 1;
  let voiceDetailList: VoiceDetailResult[] = [];
  let promise = handleSearch(1);

  // select用にデータを整形
  function formatSelectDate(dt: Date) {
    let y: string = String(dt.getFullYear());
    let m: string = ('00' + (dt.getMonth() + 1)).slice(-2);
    return { name: y + '/' + m, param: y + m };
  }

  // 通話明細を切り替える
  function handleChangeCallDetails() {
    voiceDetailYm = selectedParam.name;
    useym = selectedParam.param;
    promise = handleSearch(1);
  }

  async function handleSearch(pageNumber: number) {
    const repository = RepositoryFactory[HATENOHAMA];
    await repository
      .getVoiceDetail({ useym, pageNumber })
      .then((res) => {
        totalPageSize = res.totalCount;
        currentPage = pageNumber;
        voiceDetailList = res.list;
      })
      .catch((error) => {
        if (error.response.status === 403) {
          alert('セッションが切れました。再度ログインしてください。');
          loginUser.logout();
          push('/login');
        } else {
          alert('エラーが発生しました。');
          throw new Error();
        }
      });
    return voiceDetailList;
  }

  function isHikariCollabo() {
    return businessCode === 'HIKARI_COLLABO';
  }

  function isUmobiled() {
    return businessCode === 'UMOBILE_D' || businessCode === 'UMOBILE_D_ENECOM';
  }

  function isPremium() {
    return businessCode === 'UMOBILE_PREMIUM';
  }

  const pagingEvent = (pageNumber: number) => {
    if (currentPage != pageNumber) {
      promise = handleSearch(pageNumber);
      currentPage = pageNumber;
    }
  };

  const isAvailablePagination = (list) => {
    return list && list.length > 0;
  };
</script>

{#await promise}
  <Loading />
{:then voiceDetailList}
  <div class="mb-5 screen-title">
    <span class="text-gray-700 text-2xl font-bold">通話明細</span>
  </div>
  <div class="shadow rounded bg-white p-8 border-t-4 border-green-400">
    <div class="flex flex-col mb-6">
      <div class="flex-1 note self-end mb-10">
        <span class="underline">※通話明細表示対象についての注記はこちら</span>
        <div class="detail">
          ※ご利用月をプルダウンで選択すると、対象の月にご利用された通話明細が参照できます。<br />
          {#if isHikariCollabo()}
            ※通話明細は、前月～6か月前までの6か月分が参照できます(ご利用のなかった月を選択した場合、利用明細は表示されません)
          {:else}
            ※通話明細は、前々月～7か月前までの6か月分が参照できます(ご利用のなかった月を選択した場合、利用明細は表示されません)
          {/if}
        </div>
      </div>
      <div class="flex-1 flex sm:flex-col sm:items-center md:flex-row justify-between">
        <div class="flex-1">
          <span>通信年月日</span>
          <select bind:value={selectedParam} on:change={handleChangeCallDetails}>
            {#each callDates as date}
              <option value={date}>
                {date.name}
              </option>
            {/each}
          </select>
        </div>
        {#if isAvailablePagination(voiceDetailList)}
          <div class="flex-1 flex flex-col">
            <div class="flex-1 self-end">
              <Pagenation {totalPageSize} {currentPage} pageSize={20} {pagingEvent} />
            </div>
          </div>
        {/if}
      </div>
    </div>
    <div class="flex flex-col">
      <div class="flex-auto">
        <div class="overflow-x-auto">
          <div class="align-middle inline-block min-w-full">
            <div class="overflow-auto">
              <table class="min-w-full border-collapse border border-gray-800">
                <thead>
                  <tr>
                    <th colspan="4">{voiceDetailYm}</th>
                  </tr>
                  <tr>
                    <th class="w-1/4">通信開始日時</th>
                    <th class="w-1/4">通信元電話番号(発番号)</th>
                    <th class="w-1/4">通信先電話番号</th>
                    <th class="w-1/4">通信時間</th>
                  </tr>
                </thead>
                <tbody>
                  {#each voiceDetailList as voiceDetail}
                    <tr class="group">
                      <td>
                        {formatDate(voiceDetail.voiceStartDate)}
                        {formatTime(voiceDetail.voiceStartTime)}
                      </td>
                      <td>{voiceDetail.voiceSenderTel ?? '-'}</td>
                      <td>{voiceDetail.voiceDestinationTel ?? '-'}</td>
                      <td>{formatTime(voiceDetail.voiceTime) ?? '-'}</td>
                    </tr>
                  {/each}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
{/await}

<style lang="postcss">
  select {
    @apply border py-2 px-3 rounded text-sm focus:outline-none focus:ring-2 focus:ring-green-200 focus:border-transparent;
  }
  thead tr th {
    @apply border border-gray-800 px-4 py-3 text-center text-sm text-gray-700 whitespace-nowrap leading-4;
  }
  tbody tr td {
    @apply border border-gray-800 px-4 py-3 text-center text-sm text-gray-700 whitespace-nowrap leading-4;
  }
  .screen-title {
    text-align: left;
  }
  @media screen and (max-width: 640px) {
    .screen-title {
      text-align: center;
    }
  }
  .detail {
    @apply hidden absolute bg-yellow-100;
  }
  .note {
    @apply relative cursor-pointer block pl-20 text-xs;
  }
  .note:hover .detail {
    @apply block top-5 left-0 text-xs p-1;
  }
</style>
